import { AsyncCallArgs, CircularLoader, useAsyncCall, ViewDialog, ViewSection } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import RoleGroupUsersDisplay from "./parts/RoleGroupUsersDisplay";
import MainDetailsDisplay from "./parts/MainDetailsDisplay";
import UsersDialogList from "../../users/dialog/parts/UsersDialogList";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/rolesControl";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import { getFullRoleDetails } from "../../../../../axios/api/services";
import React, { useEffect, useState } from "react";
import ScrollableGridContainer from "../../../common/grid/ScrollableGridContainer";

const RoleViewDialog = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { asyncCall } = useAsyncCall();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.rolesControl.modals.view;
  });

  const [role, setRole] = useState(null);

  useEffect(() => {
    if (open && id) {
      const getRoleUsersCallArgs: AsyncCallArgs = {
        promise: getFullRoleDetails(id),
        onSuccess: (response) => {
          setRole(response);
        },
        onError: () => {
          setRole(null);
          dispatch(closeModal({ modalType: "view" }));
        },
      };
      asyncCall(getRoleUsersCallArgs);
    }
  }, [open, id, asyncCall, dispatch, t]);

  return (
    <div>
      <ViewDialog open={open} onClose={() => dispatch(closeModal({ modalType: "view" }))} title={"t.role.view.dialog"}>
        {!role && <CircularLoader />}
        {role && (
          <>
            <MainDetailsDisplay record={role.role} />

            <ViewSection label={"t.role.users"}>
              <ScrollableGridContainer>
                <UsersDialogList users={role.users} isEdit={false} />
              </ScrollableGridContainer>
            </ViewSection>

            <RoleGroupUsersDisplay role={role} />
          </>
        )}
      </ViewDialog>
    </div>
  );
};

export default RoleViewDialog;
